import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Paper, IconButton, Box, Collapse, Typography } from '@material-ui/core';
import { Table } from '../../custom-components';
import { baseTableSx } from '../../custom-components/Table/Table.helpers';
import configs from './config';
import { capitalize } from 'lodash';
import Region from '../../constants/region';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '15px 15px',
    },
    content: {
        margin: '0px 30px',
    },
}));

const DropoffStatistics = ({ data, region, loading }) => {
    const [expanded, setExpanded] = useState(false);
    const [statistics, setStatistics] = useState([]);
    const classes = useStyles();
    const handleSetExpanded = () => {
        setExpanded(!expanded);
    };

    const config = configs[region];

    // Don't render anything if we don't have a config
    if (!config) {
        return <>{}</>;
    }

    const { columns } = config();

    useEffect(() => {
        if (region === Region.CDI && data) {
            const mappedData = Object.entries(data).map((entry, idx) => {
                const [processor, totals] = entry;
                return {
                    processor: capitalize(processor),
                    idx,
                    ...totals,
                };
            });

            setStatistics(mappedData);
        } else {
            setStatistics(data ?? []);
        }
    }, [data]);

    const render = () => {
        return (
            <Paper className="p-12">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography className={classes.content} variant="h6">
                        Summary
                    </Typography>
                    {(!statistics || loading) && (
                        <Box sx={{ width: '50%' }}>
                            <LinearProgress />
                        </Box>
                    )}
                    <Box className={classes.content} display="flex" alignItems="center">
                        <IconButton onClick={handleSetExpanded} disabled={!data}>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>
                </Box>
                <Collapse in={expanded}>
                    <div className="flex flex-col md:flex-row sm:p-8 container">
                        <div className="flex flex-1 flex-col min-w-0 p-12">
                            <Table
                                sx={baseTableSx}
                                getRowId={(row) => row._id ?? row.id ?? `${row.processor}-${row.idx}`}
                                rows={statistics}
                                columns={columns}
                                pagination
                                loading={loading}
                                // wrap
                            />
                        </div>
                    </div>
                </Collapse>
            </Paper>
        );
    };

    return <>{render()}</>;
};

export default DropoffStatistics;
